// removed by extract-text-webpack-plugin
module.exports = {"numberInfo":"antd-pro_-_-scaffold-src-components-Charts-NumberInfo-numberInfo","suffix":"antd-pro_-_-scaffold-src-components-Charts-NumberInfo-suffix","subTotal":"antd-pro_-_-scaffold-src-components-Charts-NumberInfo-subTotal","numberInfolight":"antd-pro_-_-scaffold-src-components-Charts-NumberInfo-numberInfolight"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/NumberInfo/index.less
// module id = 425
// module chunks = 0 1